import * as types from '../../constants/log/gameSessionLogConstants';

export const gameSessionLogListRequest = (
  {
    page,
    pageLength,
    beginDate,
    endDate,
    account,
    nftUid,
    campaignNo,
    callback,
    error
  }
) => ({
  type: types.GAMESESSIONLOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  nftUid,
  campaignNo,
  callback,
  error
});

export const gameSessionLogList = (list) => ({
  type: types.GAMESESSIONLOG_LIST,
  list
});

export const setTotalCount = (totalCount) => ({
  type: types.SET_TOTAL_COUNT,
  totalCount,
});

export const setGameSessionLogPagination = (
  page, totalCount, beginDate, endDate, searchCode, searchString
) => ({
  type: types.SET_GAMESESSIONLOG_PAGINATION,
  page,
  totalCount,
  beginDate,
  endDate,
  searchCode,
  searchString,
});

export const gameSessionLogPageReset = () => ({
  type: types.GAMESESSIONLOG_PAGE_RESET,
});
